import Vue from 'vue'
import VeeValidate from 'vee-validate'

const config = {
  locale: 'tc',
  events: 'input',
  dictionary: {
    en: {
      messages: {
        required: (field) => field + ' は空白にしてはいけません。',
        min: (field, args) => field + ' は ' + args + ' 文字以上の英数字が必要です。',
        max: (field, args) => field + ' は ' + args + ' 文字以下の英数字でなければならない。',
        digits: (field, args) => field + ' の数は ' + args + ' であることが必要です。',
        min_value: (field, args) => field + ' は ' + args + ' 以上であることが必要です。',
        max_value: (field, args) => field + ' は ' + args + ' 以下であることが必要です。',
        integer: (field) => field + ' は整数でなければならない。',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' は ' + args + ' でなければならない。',
        regex: (field) => field + ' が間違っています。',
        email: () => 'メールアドレスを正しく入力してください。',
        confirmed: () => 'パスワードの入力が間違っています。'
      },
      attributes: {
      }
    },
    tc: {
      messages: {
        required: (field) => field + ' は空白にしてはいけません。',
        min: (field, args) => field + ' は ' + args + ' 文字以上の英数字が必要です。',
        max: (field, args) => field + ' は ' + args + ' 文字以下の英数字でなければならない。',
        digits: (field, args) => field + ' の数は ' + args + ' であることが必要です。',
        min_value: (field, args) => field + ' は ' + args + ' 以上であることが必要です。',
        max_value: (field, args) => field + ' は ' + args + ' 以下であることが必要です。',
        integer: (field) => field + ' は整数でなければならない。',
        mimes: (field, args) => field + ' should be mime ' + args,
        ext: (field, args) => field + ' should be extension ' + args,
        dimensions: (field, args) => field + ' は ' + args + ' でなければならない。',
        regex: (field) => field + ' が間違っています。',
        email: () => 'メールアドレスを正しく入力してください。',
        confirmed: () => 'パスワードの入力が間違っています。'
      },
      attributes: {
      }
    }
  }
}

Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/plugins/validation.js